import script from "./ObstructiveError.vue.js?vue&type=script&setup=true&lang=js!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ObstructiveError.vue?vue&type=script&setup=true&lang=js"
export * from "./ObstructiveError.vue.js?vue&type=script&setup=true&lang=js!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ObstructiveError.vue?vue&type=script&setup=true&lang=js"

import "./ObstructiveError.vue.scss?vue&type=style&index=0&id=8d8ff28e&lang=scss!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ObstructiveError.vue?vue&type=style&index=0&id=8d8ff28e&lang=scss"

const __exports__ = script;

export default __exports__